module.exports = __webpack_public_path__ + "pdf-icon.png?c6ba8e7ba2b4c86a8d3fd26aa4248375";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf-icon.png
// module id = 946
// module chunks = 0